import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

document.title = 'Manjeev Takhar - Portfolio';

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
